export { default as SellerListTemplate } from './SellerListTemplate';
export { default as SellerCreateTemplate } from './SellerCreateTemplate';
export { default as SellerEditTemplate } from './SellerEditTemplate';
export { default as SellerEdit3PLCredentialsTemplate } from './SellerEdit3PLCredentialsTemplate';
export { default as SellerWarehouseTemplate } from './SellerWarehouseTemplate';



// WEBPACK FOOTER //
// ./src/themes/default/modules/seller/pages/index.js